{
  "name": "npm-web-sampler",
  "version": "3.0.5",
  "description": "npm packages sampler",
  "source": "build/index.html",
  "browserslist": "> 0.5%, last 2 versions, not dead",
  "type": "commonjs",
  "scripts": {
    "scripts:prepare": "bash repositories/commons/scripts/prepare.ba.sh",
    "bower:update": "npx bower update --allow-root",
    "prebower:install": "npm run bower:update",
    "bower:install": "npx bower install --allow-root",
    "postbower:install": "npm run scripts:prepare",
    "npm:upgrade": "npm install --location=global npm@latest",
    "pre_npm:install:global": "npm run npm:upgrade",
    "_npm:install:global": "npm install --location=global",
    "npm:install:global:all": "npm run _npm:install:global -- yarn bower @executeautomation/playwright-mcp-server @github/copilot @anthropic-ai/claude-code @google/gemini-cli",
    "npm:install:global:ci": "npm install --location=global --force bower",
    "npm:install:global:Dockerfile": "npm run npm:upgrade",
    "playwright:install": "npx playwright install",
    "_pip": "python -m pip",
    "pip:freeze": "python -m pip freeze > requirements.frozen.txt",
    "_pip:install": "npm run _pip -- install --break-system-packages",
    "_pip:install:upgrade": "npm run _pip:install -- --upgrade",
    "pip:upgrade:pip": "npm run _pip:install:upgrade -- pip",
    "prepip:upgrade:requirements": "npm run pip:upgrade:pip",
    "pip:upgrade:requirements": "npm run _pip:install:upgrade -- -r ./requirements.upgrade.txt",
    "prepip:install:requirements": "npm run pip:upgrade:requirements",
    "pip:install:requirements": "npm run _pip:install -- -r ./requirements.txt",
    "pipx:ensurepath": "pipx ensurepath",
    "pipx:install:requirements": "bash _scripts/pipx/install.ba.sh",
    "postpip:install:requirements": "npm run pip:freeze",
    "helm:lint": "helm lint ./helm/npm-web-sampler/ --strict",
    "setup": "npm run npm:install:global:all && npm run playwright:install && npm run bower:install && npm run pip:install:requirements && npm run pipx:install:requirements",
    "setup:ci": "npm run npm:install:global:ci && npm run bower:install && npm run pip:install:requirements && npm run pipx:install:requirements",
    "setup:semantic-release": "npm run npm:install:global:ci && npm run scripts:prepare && npm run pip:install:requirements && npm run pipx:install:requirements",
    "setup:Dockerfile:dev": "npm run npm:install:global:Dockerfile && npm run pip:install:requirements && npm run pipx:ensurepath && npm run pipx:install:requirements",
    "setup:Dockerfile:prd": "npm install --production http-server",
    "yarn:licenses:prod:list": "npx yarn licenses list --prod > build/vendor/LICENSES.txt",
    "yarn:licenses:prod:generate-disclaimer": "npx yarn licenses generate-disclaimer --prod > build/vendor/LICENSES.md",
    "yarn:licenses:prod:all": "npm run yarn:licenses:prod:list && npm run yarn:licenses:prod:generate-disclaimer",
    "LICENSES": "npm run yarn:licenses:prod:all",
    "mega-linter": "mega-linter-runner",
    "_prettier": "prettier .",
    "prettier:check": "npm run _prettier -- --check",
    "prettier:write": "npm run _prettier -- --write",
    "grunt": "npx grunt --verbose --color",
    "grunt:htmllint": "npm run grunt -- htmllint",
    "grunt:clean": "npm run grunt -- clean",
    "grunt:copy": "npm run grunt -- copy",
    "grunt:concat": "npm run grunt -- concat",
    "grunt:build": "npm run grunt -- build",
    "standardx": "standardx *.js __tests__/**/*.js --verbose",
    "standardx:check": "npm run standardx",
    "standardx:fix": "npm run standardx -- --fix",
    "dockerlint": "dockerlint -d",
    "dockerlint:Dockerfile": "npm run dockerlint -- -f Dockerfile",
    "dockerlint:Dockerfile.next": "npm run dockerlint -- -f Dockerfile.next",
    "dockerlint:all": "npm run dockerlint:Dockerfile && npm run dockerlint:Dockerfile.next",
    "_terraform": "terraform -chdir=./terra",
    "terraform:fmt": "npm run _terraform -- fmt -recursive -diff -list=true",
    "terraform:fmt-check": "npm run terraform:fmt -- -check",
    "lint-staged": "lint-staged",
    "lint:misc": "npm run prettier:check",
    "lint:misc2": "npm run mega-linter",
    "lint:js": "npm run standardx:check",
    "lint:html": "npm run grunt:htmllint",
    "lint:docker": "npm run dockerlint:all",
    "lint:helm": "npm run helm:lint",
    "lint:terraform": "npm run terraform:fmt-check",
    "lint": "npm run prettier:check && npm run standardx:check && npm run grunt:htmllint && npm run helm:lint && npm run terraform:fmt-check",
    "format": "npm run prettier:write && npm run standardx:fix && npm run terraform:fmt",
    "postformat": "npm run lint",
    "style": "npm run format",
    "update-browserslist-db": "npx update-browserslist-db@latest",
    "jest:ci": "jest --ci --coverage",
    "XXX_prejest:ci:unit": "npm run update-browserslist-db",
    "jest:ci:unit": "npm run jest:ci -- unit.spec.js",
    "jest:ci:rest": "npm run jest:ci -- rest.spec.js",
    "jest:ci:rest:npm-web-sampler": "npm run jest:ci:rest -- --rootDir=__tests__/npm-web-sampler",
    "jest:ci:rest:google": "npm run jest:ci:rest -- --rootDir=__tests__/com/google",
    "jest:ci:rest:HTTPbin": "npm run jest:ci:rest -- --rootDir=__tests__/org/HTTPbin",
    "jest:playwright": "jest --detectOpenHandles --forceExit --testTimeout=60000 --rootDir=__tests__/ pw.spec.js",
    "postjest:playwright": "npm run format",
    "jest:selenium": "jest --verbose --runInBand --detectOpenHandles --forceExit --testTimeout=60000 se.spec.js",
    "testem:ci": "testem ci",
    "testem:ci:dot": "npm run testem:ci -- --reporter dot",
    "testem:ci:tap": "npm run testem:ci -- --reporter tap > test/results/browsers/testem.tap",
    "testem:ci:xunit": "npm run testem:ci -- --reporter xunit > test/results/browsers/testem.xunit.xml",
    "testem:ci:all": "npm run testem:ci:tap && npm run testem:ci:xunit",
    "selenium-side-runner:TestCases": "selenium-side-runner selenium/side/TestCases.side",
    "parcel": "parcel",
    "parcel:build": "parcel build --public-url ./",
    "pretest": "npm run lint",
    "test": "npm run jest:ci:unit",
    "predev": "npm run format",
    "dev": "npm run test",
    "semantic-release": "semantic-release",
    "tag": "npm run semantic-release",
    "build": "npm run grunt:build && npm run LICENSES",
    "predist": "npm run grunt:build && npm run LICENSES",
    "dist": "npm run parcel:build",
    "husky": "husky",
    "husky:install": "husky",
    "husky:uninstall": "git config --unset core.hooksPath",
    "http-server:dist": "npx http-server ./dist --port 8080",
    "XXX_serve:dist": "npx serve -s dist -l 8080",
    "docker:registry:run": "docker run -d -p 5000:5000 --name registry registry:2.7",
    "docker:registry:logs": "docker logs registry",
    "docker:this:build": "docker build --no-cache --pull --tag npm-web-sampler:local .",
    "docker:this:build:test": "npm run docker:this:build -- --target test",
    "docker:this:push": "docker push npm-web-sampler:local",
    "docker:this:images": "docker images --all | grep -a 'npm-web-sampler'",
    "docker:this:images:rm": "docker images --all | grep -a 'npm-web-sampler' | awk '{print $3}' | xargs docker rmi --force",
    "docker:this:run": "docker run -p 8080:8080 npm-web-sampler",
    "docker:this:run:ls": "npm run docker:this:run -- ls -la",
    "docker:this:run:default": "npm run docker:this:run",
    "docker:this:containers": "docker ps --all | grep -a 'npm-web-sampler'",
    "docker:this:containers:running": "docker ps --all --filter status=running | grep -a 'npm-web-sampler'",
    "docker:this:containers:stop": "docker ps --all --filter status=running | grep -a 'npm-web-sampler' | awk '{print $1}' | xargs docker stop",
    "docker:this:clean": "npm run docker:this:containers:stop && npm run docker:this:images:rm",
    "docker:all:exited:containers:rm": "docker ps --all --filter status=exited | tail -n +2 | awk '{print $1}' | xargs docker rm",
    "docker:all:prune": "docker builder prune --all --force",
    "_docker:all:containers:rm": "docker rm $(docker ps --all --quiet)",
    "predocker:clean": "npm run docker:this:images:rm",
    "docker:clean": "npm run docker:all:exited:containers:rm && npm run docker:all:prune",
    "docker:compose:up": "docker compose up --build --remove-orphans",
    "minikube:start": "minikube start",
    "verify": "npm test && npm run dist",
    "verify:docker": "npm run docker:this:build:test",
    "browser": "open-cli http://127.0.0.1:8080",
    "FIXME_prestart": "npm run dist",
    "start": "npm run parcel",
    "FIXME_prestart:http-server": "npm run dist",
    "start:http-server": "npm run http-server:dist",
    "start:docker": "npm run docker:compose:up"
  },
  "standardx": {
    "env": [
      "jest"
    ]
  },
  "repository": {
    "type": "git",
    "url": "git+https://github.com/percebus/npm-web-sampler.git"
  },
  "keywords": [
    "npm",
    "git",
    "html",
    "lint",
    "grunt",
    "jest",
    "frisby"
  ],
  "author": "percebus",
  "license": "SEE LICENSE IN LICENSE.md",
  "bugs": {
    "url": "https://github.com/percebus/npm-web-sampler/issues"
  },
  "homepage": "https://github.com/percebus/npm-web-sampler#readme",
  "devDependencies": {
    "@playwright/test": "^1.60.0",
    "@semantic-release/changelog": "^6.0.3",
    "@semantic-release/commit-analyzer": "^13.0.1",
    "@semantic-release/exec": "^7.1.0",
    "@semantic-release/git": "^10.0.1",
    "@semantic-release/github": "^11.0.3",
    "@semantic-release/npm": "^12.0.1",
    "@semantic-release/release-notes-generator": "^14.0.3",
    "browserslist": "latest",
    "dockerlint": "^0.3.9",
    "eslint-config-prettier": "^10.1.8",
    "frisby": "^2.1.3",
    "grunt": "^1.6.1",
    "grunt-contrib-clean": "^2.0.1",
    "grunt-contrib-concat": "^2.1.0",
    "grunt-contrib-copy": "^1.0.0",
    "grunt-contrib-cssmin": "^5.0.0",
    "grunt-htmllint": "^0.3.0",
    "husky": "^9.1.7",
    "jest": "^30.2.0",
    "jest-environment-jsdom": "^30.4.1",
    "jest-github-actions": "^0.5.0",
    "jest-junit": "^16.0.0",
    "lint-staged": "^16.2.6",
    "load-grunt-tasks": "^5.1.0",
    "lodash": "^4.17.21",
    "mega-linter-runner": "^8.7.0",
    "parcel": "~2.14.2",
    "posthtml-doctype": "^1.1.1",
    "prettier": "^3.5.3",
    "selenium-side-runner": "^4.0.13",
    "selenium-webdriver": "^4.32.0",
    "standardx": "^7.0.0",
    "testem": "^3.16.0",
    "update-browserslist-db": "latest"
  },
  "dependencies": {
    "bootstrap": "^5.3.6"
  }
}
